import React, { useState } from 'react';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import ValueDetailsRow from '../../components/ValueDetailsRow';
import ExtraFields from '../../components/ExtraFields';
import { SummaryRow } from '../../components/SummaryRow';

export default function InputValuesShow() {
  const {
    totalInputValuesComputed,
    inputsTag,
    insuranceCoopercargaValue,
    customerFields,
    inputsExtraFields,
    goldenShippingCompany,
    shouldUseToll,
    shouldUseDischarge,
    shouldUseGrisAd,
    shouldUseCharge,
    shouldUseFerry,
    shouldUseICMS,
  } = useFreightValues();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Descontos e Insumos Pré-Taxa"
        isOpen={isOpen}
        onToggleCard={() => setIsOpen(!isOpen)}
        tooltipContent="Todo valor que precisa descontar antes de tirar a taxa (margem) é alocado neste campo, assim, é chegado no percentual correto para desconto de taxa administrativa (Margem)"
        totalsSection={
          <HeaderTotalSummary
            label="Valor insumos"
            totalInReal={totalInputValuesComputed.total}
            totalInDollar={totalInputValuesComputed.totalDollarValue}
          />
        }
        hasTagsRow
        tagsContent={inputsTag}
      />
      {isOpen && (
        <>
          {insuranceCoopercargaValue?.value > 0 && (
            <ValueDetailsRow
              label="Seguro Coopercarga"
              value={insuranceCoopercargaValue?.value}
              dollarValue={insuranceCoopercargaValue?.dollarValue}
              percentageValue={insuranceCoopercargaValue?.percentage}
              hasTooltip
              tooltipContent="Valor aproximado, pode variar de acordo com o valor do produto na Nota Fiscal"
            />
          )}
          {shouldUseToll > 0 && (
            <ValueDetailsRow
              label="Pedágio"
              value={customerFields?.tollValue?.value}
              dollarValue={customerFields?.tollValue?.dollarValue}
              obs={customerFields?.tollValue?.action?.name}
            />
          )}
          {shouldUseDischarge > 0 && (
            <ValueDetailsRow
              label="Descarga"
              value={customerFields?.dischargeValue?.value}
              dollarValue={customerFields?.dischargeValue?.dollarValue}
              obs={customerFields?.tollValue?.action?.name}
            />
          )}
          {shouldUseGrisAd > 0 && (
            <ValueDetailsRow
              label="Griss"
              value={customerFields?.gris?.value}
              dollarValue={customerFields?.gris?.dollarValue}
              percentageValue={customerFields?.gris?.percentage}
              obs={customerFields?.gris?.action?.name}
              hasTooltip
              tooltipContent="Valor aproximado, pode variar de acordo com o valor do produto na Nota Fiscal"
            />
          )}
          <>
            <ValueDetailsRow
              label="Ad valorem"
              value={customerFields?.adValorem?.value}
              dollarValue={customerFields?.adValorem?.dollarValue}
              percentageValue={customerFields?.adValorem?.percentage}
              obs={customerFields?.gris?.action?.name}
            />
            {goldenShippingCompany && Number(customerFields?.adValorem?.value || 0) > 0 && (
              <ValueDetailsRow
                label="Ad valorem"
                value={customerFields?.adValorem?.value}
                dollarValue={customerFields?.adValorem?.dollarValue}
                percentageValue={customerFields?.adValorem?.percentage}
                obs={customerFields?.gris?.action?.name}
                color="danger"
                wasValueRemovedFromTotal={goldenShippingCompany}
              />
            )}
          </>
          {shouldUseFerry > 0 && (
            <ValueDetailsRow
              label="Balsa"
              value={customerFields?.ferry?.value}
              dollarValue={customerFields?.ferry?.dollarValue}
              obs={customerFields?.ferry?.action?.name}
            />
          )}
          {shouldUseCharge > 0 && (
            <ValueDetailsRow
              label="Taxa de carregamento"
              value={customerFields?.chargeValue?.value}
              dollarValue={customerFields?.chargeValue?.dollarValue}
              obs={customerFields?.chargeValue?.action?.name}
            />
          )}
          {shouldUseICMS > 0 && (
            <ValueDetailsRow
              label="ICMS"
              value={customerFields?.ICMS?.value}
              dollarValue={customerFields?.ICMS?.dollarValue}
              percentageValue={customerFields?.ICMS?.percentage}
              obs={customerFields?.ICMS?.action?.name}
            />
          )}
          {inputsExtraFields?.length > 0 ? (
            <>
              <Text type="regular" weight={500}>
                Valores extras
              </Text>
              <ExtraFields show fields={inputsExtraFields} />
            </>
          ) : null}
          <SummaryRow
            label="Valor Insumos"
            totalInReal={totalInputValuesComputed?.total}
            totalInDollar={totalInputValuesComputed?.totalDollarValue}
            id="valor-insumo"
          />
        </>
      )}
    </Card>
  );
}
